module.exports = __webpack_public_path__ + "images/896a2ccf75a7603c4c252a82295d0af5.png";